import apiClient from "@/shared/api/apiClient";

export default class DefaultAuthPort {
  constructor() {}

  /**
   * Авторизация по логину и паролю
   * @param {{ username: string, password: string }} credentials
   * @returns {Promise<{ _success: boolean, authorizationToken?: string, message?: string }>}
   */
  async loginWithCredentials(credentials) {
    try {
      const response = await this.apiClient.post("/auth/login", credentials);

      // Пример ожидаемого ответа от бэкенда
      // { _success: true, authorizationToken: "abc123" }

      if (response.data && response.data._success) {
        return {
          _success: true,
          authorizationToken: response.data.authorizationToken,
        };
      }

      return {
        _success: false,
        message: response.data?.message || "Неверный логин или пароль",
      };
    } catch (error) {
      console.error("Ошибка при авторизации:", error);
      return {
        _success: false,
        message: error.response?.data?.message || "Ошибка сети",
      };
    }
  }
  reset(username) {
    const formData = new FormData();
    formData.append("login", username);

    return fetch(`${apiClient}/admin/login/restore`, {
      method: "POST",
      body: formData,
      credentials: "include",
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          return {
            _success: true,
            message:
              "На почту, указанную в профиле, отправлена ссылка для сброса пароля",
          };
        }
        return { _success: false, message: res.reason };
      })
      .catch((err) => {
        return { _success: false, message: err.message };
      });
  }

  async logout() {
    try {
      await apiClient.post("/auth/logout");
      return { _success: true };
    } catch (err) {
      console.error("logout failed", err);
      return {
        _success: false,
      };
    }
  }
}
